import { render, staticRenderFns } from "./OnboardingAwaiting.vue?vue&type=template&id=0c6714a7&"
import script from "./OnboardingAwaiting.vue?vue&type=script&lang=js&"
export * from "./OnboardingAwaiting.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingAwaiting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports